Backbone.Radio.channel('views').reply('form-terms',function(options){
	var opts = {
		 donationType:(options.pledgeData && options.pledgeData.type)?options.pledgeData.type:'sustainer'
		,donationAmount:(options.pledgeData && options.pledgeData.amount)?options.pledgeData.amount:0
		,paymentType:'CREDITCARD'
		,frequency:"M" //for installments
	}
	
	var radio = Backbone.Radio.channel('pledgeform')
	
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-terms").html())
		,onAttach:function(){
			var that = this;
			
			that.updateText();
			
			radio.on("donation:updated",function(data){
				opts.donationType = data.type;
				opts.donationAmount = data.amount;
				opts.frequency = data.frequency;
				that.updateText();
			})
			
			radio.on("paymentMethod:updated",function(data){
				opts.paymentType = data.type;
				that.updateText();
			})
			
		}
		,updateText:function(){
			var  showTerms = false
				,copy = ""
				,freq = 'each month';

			if(Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter){
				if(opts.donationType==="normal" && opts.paymentType==="EFT"){
					showTerms = true;
					copy = "<p class='volunteerText font-bold mb0'>Please read to donor:</p><p> You are authorizing WHRO to withdraw your gift of "+accounting.formatMoney(opts.donationAmount)+" from your bank account. This authorization will expire at the conclusion of this transaction.</p>";
				}else if(opts.donationType==="sustainer"){
					showTerms=true;
					if(opts.paymentType==="EFT"){
						copy = "<p class='volunteerText font-bold mb0'>Please read to donor:</p><p>You are authorizing WHRO to withdraw your sustainer membership from your bank account each month. This authorization will remain in effect until you notify WHRO to change or end this agreement.</p>";
					}else{ //credit card
						copy = "<p class='volunteerText font-bold mb0'>Please read to donor:</p><p>I need to confirm that you understand you are joining WHRO as a sustaining member and that a monthly charge will appear on your credit card until you notify WHRO to change or end this agreement.</p>";
					}
				}else if(opts.donationType==="installment" && opts.paymentType==="EFT"){
					showTerms=true;
					if(opts.frequency==="Q"){
						freq = "each quarter";
					}
					copy = "<p class='volunteerText font-bold mb0'>Please read to donor:</p><p>You are authorizing WHRO to withdraw your installment membership from your bank account "+freq+". This authorization will remain in effect until your pledge is completed.</p>";
				}
				
			}else{
				
				if(opts.donationType==="sustainer"){
					showTerms = true;
					if(opts.paymentType === "EFT"){
						copy = "<p>I authorize WHRO to withdraw my sustainer membership from my bank account each month. This authorization will remain in effect until I notify WHRO to change or end this agreement. To contact WHRO member service, I may call 757-889-9499.</p>";
					}else{
						copy = "<p>I understand that I am joining WHRO as a sustainer member and that a monthly charge will appear on my credit card until I notify WHRO to change or end this agreement.</p>"			
					}
				}
				
			}
			
			
			if(showTerms){
				$('#termsHeader').show()
				$('#termsContainer').find('.textTarget').html(copy).end().show()
			}else{
				$('#termsHeader').hide()
				$('#termsContainer').find('.textTarget').html(copy).end().hide()
			}
		}
	})
	
	
	return new (view)();
});